

exports.__esModule = true;
exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;

var _$DEFAULT, _$CONTEXT$FULLPAGE, _$integration$init;

var _squid = require('squid');

Object.defineProperty(exports, '$integration', {
    enumerable: true,
    get: function get() {
        return _squid.$integration;
    }
});
Object.defineProperty(exports, '$CONTEXT', {
    enumerable: true,
    get: function get() {
        return _squid.$CONTEXT;
    }
});
var $FLOWS = exports.$FLOWS = {
    // Regular end-to-end checkout flow with one entry and one exit point
    CHECKOUT: 'CHECKOUT',

    // Partner flow [ TODO: FACTOR THIS OUT ]
    PARTNER: 'PARTNER',

    // Native checkout flow
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};

_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
    REDIRECT_TOP: true,
    REDIRECT_QUERY_PARAM: false

}, _$DEFAULT[$FLOWS.PARTNER] = {
    REDIRECT_TOP: false
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = {
    REDIRECT_TOP: false
}, _$integration$init));

angular.value("$FLOWS", $FLOWS);
_squid.$integration;

_squid.$DEFAULT;

_squid.$CONTEXT;


//////////////////
// WEBPACK FOOTER
// ./js/lib/integration.js
// module id = ./js/lib/integration.js
// module chunks = 0